<template>
  <div class="app-box login-bg">
    <div class="login-box">
      <h3>e互助风控系统</h3>
      <div class="login">
        <h5>管理员登录</h5>
        <div v-if="error" class="login-error">{{ errorMsg }}</div>
        <div class="form-group">
          <el-input
            v-model="username"
            suffix-icon="iconfont icon-zhanghu"
            placeholder="账号"
            clearable
            @keyup.enter.native="login"
          />
        </div>
        <div class="form-group">
          <el-input
            v-model="password"
            placeholder="请输入密码"
            show-password
            @keyup.enter.native="login"
          />
        </div>
        <el-button type="primary" class="btn-primary" @click="login">登录</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: '',
      password: '',
      captcha: '',
      error: false,
      errorMsg: ''
    }
  },

  computed: {},

  methods: {
    login() {
      const vm = this
      const data =
        'username=' + vm.username + '&password=' + vm.password + '&captcha=' + vm.captcha

      vm.axios
        .post(vm.homePath() + '/sys/login', data)
        .then((response) => {
          const data = response.data
          if (data && data.status === '000000') {
            // 登录成功
            vm.$router.push('/index')
          } else {
            vm.error = true
            vm.errorMsg = data.message
          }
        })
        .catch()
    }
  }
}
</script>

<style>
.login-bg {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background-color: #d2d6de;
}

.login-box {
  width: 360px;
  height: auto;
  margin: 0 auto;
  margin-top: 7%;
}

.login-box h3 {
  text-align: center;
  font-size: 35px;
  font-weight: 700;
  color: #333;
}

.login {
  background: #fff;
  padding: 20px;
  margin-top: 25px;
  overflow: hidden;
}

.login h5 {
  font-size: 14px;
  color: #666;
  text-align: center;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 20px;
}

.login-error {
  padding: 12px;
  padding-left: 35px;
  background: #d73925 url(../assets/img/icon01.png) 10px 15px no-repeat;
  background-size: 18px auto;
  color: #fff;
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 3px;
  border: 1px solid transparent;
  margin-top: 20px;
}

.login-error::before {
  content: "";
  width: 18px;
  height: auto;
}

.login-input {
  width: 100%;
  display: block;
  padding: 5px 12px;
  font-size: 14px;
  color: #555;
  background-color: #fff;
  border: 1px solid #ccc;
}

.name-input {
  background: url(../assets/img/icon02.png) 97% center no-repeat;
  background-size: 14px 16px;
  padding-right: 25px;
}

.password-input {
  background: url(../assets/img/icon03.png) 97% center no-repeat;
  background-size: 13px 16px;
  padding-right: 25px;
}

.btn-primary {
  width: 100px;
  float: right;
}
</style>
